// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandService = {};
// console.log("🚀 ~ AssetBrandService:", AssetBrandService);

AssetBrandService.postAssetBrand = function (data) {
  return lossClient({
    url: "/AssetBrand/add",
    method: "post",
    data: data,
  });
};

AssetBrandService.getAssetBrandList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // console.log(
  //   "🚀 ~ file: AssetBrandService.js:17 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetBrandService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetBrand/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetBrandService.getAssetBrandApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: AssetBrandService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetBrandService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetBrand/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetBrandService.putAssetBrandApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { UserId: data.userId }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag == "approve"
      ? { UserId: data.userId, Note: data.note }
      : { UserId: data.userId, Note: data.note };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/AssetBrand/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

AssetBrandService.putAssetBrandRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/AssetBrand/${data?.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data?.id,
    },
    data: bodyRequest,
  });
};

AssetBrandService.getAssetBrandDetail = function (data) {
  return lossClient({
    url: `/AssetBrand/${data.id}`,
    method: "get",
  });
};

AssetBrandService.updateAssetBrand = function (data) {
  // console.log("🚀 ~ data:", data);
  const { id, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/AssetBrand/Edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

AssetBrandService.deleteAssetBrand = function (data) {
  // console.log("🚀 ~ AssetBrandService.deleteAssetBrand ~ data:", data);
  const { AssetBrandId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/AssetBrand/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.AssetBrandId,
    },
    data: requestBody,
  });
};

export default AssetBrandService;
